import type { TaskResult } from "../types";

export async function gradeProject22(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 2: Verificar que el gráfico fue movido a una hoja llamada "Gráfico Trimestre 2"
  try {
    await Excel.run(async (context) => {
      // Verificar que Trimestre 2 ya no tiene gráficos
      const srcSheet = context.workbook.worksheets.getItem("Trimestre 2");
      const chartCount = srcSheet.charts.getCount();

      // Intentar encontrar la hoja de gráfico por nombre
      const chartSheet = context.workbook.worksheets.getItemOrNullObject("Gráfico Trimestre 2");
      chartSheet.load("name");
      await context.sync();

      const chartMoved = chartCount.value === 0;
      const sheetExists = !chartSheet.isNullObject;

      // Pasa si el gráfico fue movido Y la hoja destino existe con el nombre correcto
      // Si las chart sheets no aparecen en worksheets, al menos verificamos que se movió
      results.push({ taskId: 2, passed: chartMoved && sheetExists });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Formato contabilidad en columnas B, C, D y E de Trimestre 1
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Trimestre 1");
      const cells = ["B10", "C10", "D10", "E10"];
      const ranges = cells.map((addr) => {
        const r = sheet.getRange(addr);
        r.load("numberFormat");
        return r;
      });
      await context.sync();

      const allAccounting = ranges.every((r) => {
        const fmt = String(r.numberFormat[0][0] ?? "");
        return fmt.includes("$") && (fmt.includes("0.00") || fmt.includes("#,##0.00"));
      });
      results.push({ taskId: 3, passed: allAccounting });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Cambiar fila/columna — después del cambio hay 5 series (ubicaciones) en vez de 4 (meses+total)
  try {
    await Excel.run(async (context) => {
      const chart = context.workbook.worksheets.getItem("Trimestre 1").charts.getItemAt(0);
      const count = chart.series.getCount();
      await context.sync();

      results.push({ taskId: 4, passed: count.value >= 5 });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Mostrar fórmulas en Trimestre 2
  try {
    await Excel.run(async (context) => {
      const window = context.workbook.application.windows.getItemAt(0);
      window.load("showFormulas");
      await context.sync();

      results.push({ taskId: 5, passed: window.showFormulas === true });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
